import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import Modal from "./shared/modal";

import { createImportAttempt } from "../services/import_attempts";

export const InviteCoachesButton = ({ onClose }) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const [file, setFile] = useState(null);

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const open = () => {
    setShow(true);
  };

  const save = async () => {
    const { id } = await createImportAttempt(file);
    navigate('/club_admin/import_attempts/' + id)
  };

  const close = reload => {
    setShow(false);
    onClose && onClose(reload);
  };

  return (
    <div>
      <button className="button button-add" onClick={open}>
        {t("buttons.common.import-coaches")}
      </button>
      <Modal openModal={show} closeModal={() => setShow(false)}>
        <div className="dialog-content invite-dialog">
          <div className="invite-dialog-header">
            <a href="/template.csv" className="pull-right" download>
              <i className="icon-doc"></i>{t('importAttempts.new.download_csv')}
            </a>
            <h4 className="invite-dialog-title">{t('importAttempts.new.invite')}</h4>
          </div>
          <div className="form-group">
            <label htmlFor="groupName">{t("importAttempts.new.file")}</label>
            <div className="select-file">
              <input type="file" id="file" name="file" accept=".csv" required onChange={handleFileChange} />
            </div>
          </div>
        </div>

        <hr />
        <div className="form-container-actions">
          <div className="flex-end">
            <button className="button" disabled={loading} onClick={() => close(false)}>
              {t("buttons.common.cancel")}
            </button>
            <button className="button button-primary" disabled={loading} onClick={() => save(true)}>
              {t("importAttempts.new.submit")}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
